export default {
  LIST(state, data) {
    state.periods = data
  },
  UPDATE(state, value) {
    state.period = { ...value }
  },
  FRESH(state) {
    state.period = {
      id: null,
      name: '',
      info: '',
      admission_year: '',
      is_active: false,
    }
  },
  GET(state, data) {
    state.period = data
  },
}
